import { v4 as uuid4 } from 'uuid';
import { generate } from '@/services/jwtAuth.js';
import { OnCreateChatBlitzarByActivityId, OnCreateChatBlitzarByUserId, OnCreateChatBlitzarByEventId } from '@/graphql/subscriptions.js';

let wsClient;
let token;
let event_id;
let id;
let activity_id;
let user_id;
let typeQuery;

export default {
  async subscribeGraphQl(state, activity, user) {
    if (!state.user.tokenJWT) {
      return null;
    }
    event_id = state.eventId;
    activity_id = activity;
    user_id = user;
    typeQuery = user_id ? OnCreateChatBlitzarByUserId : activity_id ? OnCreateChatBlitzarByActivityId : OnCreateChatBlitzarByEventId;
    token = state.user.tokenJWT;
    const template = state.template;
    const header = {
      Authorization: token,
      host: '3ocx4ej6v5fmpkp7orlyw7fgvq.appsync-api.us-east-1.amazonaws.com',
    };

    const a = await generate(header);
    let b = '';
    let found = false;
    for (let i = 0; i < a.length; i++) {
      if (a.charCodeAt(i) == 46) {
        found = !found;
      }
      if (found && a.charCodeAt(i) != 46) b = b + a[i];
    }

    if (token.length > 0 && template.notificationConfig) {
      wsClient = new WebSocket(`wss://3ocx4ej6v5fmpkp7orlyw7fgvq.appsync-realtime-api.us-east-1.amazonaws.com/graphql?header=${b}==&payload=e30=`, 'graphql-ws');
      wsClient.addEventListener('message', this.connectingProcess);
      wsClient.addEventListener('open', () => {
        console.log('Conectado graphQL');
        wsClient.send(
          JSON.stringify({
            type: 'connection_init',
            //channel: state.eventId,
          })
        );
      });
      wsClient.addEventListener('close', () => {
        wsClient = null;
        // setTimeout(this.subscribeGraphQl(state), 6000);
      });
      wsClient.addEventListener('error', () => {
        console.error('ws error');
        wsClient.close();
      });
    }
    return wsClient;
  },

  connectingProcess(incoming) {
    let msg = JSON.parse(incoming.data);
    // console.log('Connecting MESSAGE: ', msg);

    if (msg.type == 'connection_ack') {
      id = uuid4();
      wsClient.send(
        JSON.stringify({
          id: id,
          payload: {
            data: JSON.stringify({
              query: typeQuery,
              variables: {
                event_id: event_id,
                activity_id: activity_id,
                user_id: user_id,
              },
            }),
            extensions: {
              authorization: {
                Authorization: token,
                host: '3ocx4ej6v5fmpkp7orlyw7fgvq.appsync-api.us-east-1.amazonaws.com',
                //"x-amz-user-agent": "aws-amplify/4.6.0 js"
              },
            },
          },
          type: 'start',
          //channel: state.eventId,
        })
      );
    } else if (msg.type == 'start_ack') {
    } else if (msg.type == 'data') {
      // console.log('Received = ', msg.payload.data);
      if (msg.payload.data.onCreateChatBlitzarByEventId) {
        const payload = {
          type: msg.payload.data.onCreateChatBlitzarByEventId.name,
          data: msg.payload.data.onCreateChatBlitzarByEventId.message,
        };
        const event = new CustomEvent('treating', { detail: payload });
        // console.log('DispatchEvent', payload);
        wsClient.dispatchEvent(event);
      } else if (msg.payload.data.onCreateChatBlitzarByActivityId) {
        const payload = {
          type: msg.payload.data.onCreateChatBlitzarByActivityId.name,
          data: msg.payload.data.onCreateChatBlitzarByActivityId.message,
        };
        const event = new CustomEvent('treating', { detail: payload });
        // console.log('DispatchEvent', payload);
        wsClient.dispatchEvent(event);
      }
    } else if (msg.type == 'connection_error') {
      console.log('Error: ', msg.payload.errors[0].message, msg.payload);
      return null;
    }
  },

  unsubscribe() {
    wsClient.send(
      JSON.stringify({
        id: id,
        type: 'stop',
        //channel: state.eventId,
      })
    );
  },
};
